import {$auth} from "@/plugins/auth"
import type {NavigationGuardNext, RouteLocationNormalized, RouteLocationNormalizedLoaded} from "vue-router"
import {ROUTES} from "@/router/paths"
import routeTo from "@/plugins/route"
import {Capacitor} from "@capacitor/core"

export default class RequiresOnboardingComplete implements App.Middleware.Instance {
  async handle(
    to: RouteLocationNormalized,
    from: RouteLocationNormalizedLoaded,
    next: App.Middleware.Caller,
    cancel: NavigationGuardNext
  ): Promise<void> {
    if ($auth.user && Capacitor.isNativePlatform() && !$auth.user.is_onboarding_complete) {
      return cancel(routeTo(ROUTES.ONBOARDING_PENDING))
    }

    await next(to, from, cancel)
  }
}
